/**
 * ONE normalisation for "is this string on the page?" checks.
 *
 * A source page and the copy written from it disagree on typography long before
 * they disagree on facts: a curly ’ against a straight ', an en dash against a
 * hyphen, a non-breaking space, a trailing full stop, "commitment-free" against
 * "commitment free". Comparing raw lowercase strings turns each of those into a
 * "the evidence does not support it" verdict on a phrase that is verbatim on
 * the page (ITC Tax run 3, 2026-10-01: "commitment-free second opinion",
 * "executive-ready findings memo").
 *
 * Letters and digits only, lowercased, single-spaced, accents folded. Anything
 * else (punctuation, dashes, quotes, symbols) is a separator.
 */
export function normalizeForMatch(text: string): string {
  return text
    .normalize('NFKD')
    .replace(/\p{M}+/gu, '')
    .toLowerCase()
    .replace(/[^\p{L}\p{N}]+/gu, ' ')
    .trim();
}

/** True when `needle` appears in `haystack` on word boundaries, ignoring typography. */
export function containsNormalized(haystack: string, needle: string): boolean {
  const target = normalizeForMatch(needle);
  if (target.length === 0) return false;
  return ` ${normalizeForMatch(haystack)} `.includes(` ${target} `);
}
